import { Flex, Text } from "@chakra-ui/react";
import { ComposicoesRelatorioComposicaoContas } from "core/features/relatorios/conta-com-composicoes/typings";
import moment from "moment";
import { formatMoney } from "infra/helpers/number";
import { OperacaoEnum } from "resources/enums/conta";
import { mapFormaPagamentoToLabel } from "infra/helpers/mapFormaPagamentoToLabel";

interface TableItemRowProps {
  composicao: ComposicoesRelatorioComposicaoContas;
  operacao: OperacaoEnum;
}
function TableItemRow({ composicao, operacao }: TableItemRowProps) {
  return (
    <>
      <Flex flex={1.75}>
        <Flex ml={8}>
          {composicao?.categoriaFinanceira?.breadcrumb}{" "}
          {composicao?.categoriaFinanceira?.nome}
        </Flex>
      </Flex>

      <Flex flex={0.7} justifyContent="center">
        {composicao.complemento ?? "--"}
      </Flex>
      <Flex flex={0.7} justifyContent="center">
        {composicao.dataCompetencia
          ? moment(composicao.dataCompetencia, "YYYY-MM").format("MM/YYYY")
          : "--"}
      </Flex>
      <Flex flex={0.7} justifyContent="center">
        {composicao.dataVencimento
          ? moment(composicao.dataVencimento).format("DD/MM/YYYY")
          : "--"}
      </Flex>
      <Flex flex={0.7} justifyContent="center">
        <Flex flexDir="column" gap={1}>
          <Text>
            {composicao.dataPagamento
              ? moment(composicao.dataPagamento).format("DD/MM/YYYY")
              : "--"}
          </Text>
          {composicao.formaPagamentoId ? (
            <Text fontSize={12} color="gray.600" fontWeight="medium">
              {mapFormaPagamentoToLabel(composicao.formaPagamentoId)}
            </Text>
          ) : null}
        </Flex>
      </Flex>
      <Flex flex={0.7} justifyContent="center">
        {composicao.dataMovimentacao
          ? moment(composicao.dataMovimentacao).format("DD/MM/YYYY")
          : "--"}
      </Flex>

      <Flex flex={1} justifyContent="center" textAlign="center">
        {composicao.centroDeCusto?.nome ?? "--"}
      </Flex>

      <Flex flex={0.6} justifyContent="flex-end">
        {composicao.valor
          ? formatMoney(
              composicao.valor *
                composicao.categoriaFinanceira.operacao *
                operacao,
              true,
            )
          : "--"}
      </Flex>

      <Flex flex={1}>{composicao.tenantConta?.nome ?? "--"}</Flex>

      <Flex flex={1.75}>
        {composicao.descricao ? composicao.descricao : "--"}
      </Flex>

      <Flex flex={0.8}>{composicao.nossoNumero ?? "--"}</Flex>
    </>
  );
}

export default TableItemRow;
